import { PhoneCallIcon } from '@phosphor-icons/react'
import type { NodeProps } from '@xyflow/react'
import type { InitiateCallFlowNode } from 'app/types/workflows'
import { NodeShell } from './NodeShell'

/** Click-to-call: ring a number, then bridge it to the contact. */
export function InitiateCallNode({ data, selected }: NodeProps<InitiateCallFlowNode>) {
  return (
    <NodeShell
      icon={PhoneCallIcon}
      accent="rose"
      kind="Initiate call"
      label={data.label}
      description={`Ring ${data.ringNumber?.trim() || `a number`} → the contact`}
      selected={selected}
    />
  )
}
